
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/search",
      function () {
        return require("private-next-pages/profile/search.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/search"])
      });
    }
  